<template lang="pug">
    .play-box(:class="{'revived-numbers-game-container_before-start': gameFinished}")
        template
            template(v-if='!isLoading')
                game-header(
                    :time='getTime'
                    :slug='type'
                    :game-type='parameters && parameters.courseType'
                    @soundStateChanged="headerKey = !headerKey",
                    :key="headerKey",
                    :is-homework="!!exerciseId"
                )
                .component-container(v-if="!gameFinished")
                  .component-container__block
                      rooms
                      answer-container(
                        :grouped-correct-answers-array-of-rows="groupedCorrectAnswersArrayOfRows"
                        :game-started="gameStarted"
                        :array-of-answers="arrayOfAnswers"
                        :answers-for-each-turn="answersForEachTurn"
                        @chooseElement="chooseElement"
                        @checkAnswers="checkAnswers"
                      )
                  .button-wrapper
                      cs-button.list__button(v-if="!gameStarted" color="blue" @click="startGame")
                          | {{ $i18n.t('trainer.trainer_gamePlayBox_memorize') }}
                fireworks(v-if='gameFinished' :is-mobile='isMobile')
                .revived-numbers-game-container__result-container(
                    v-if='gameFinished'
                )
                    .play-box__reaction-container
                        .play-box__reaction
                            result-image.play-box__image(:status='"success"')
                            .play-box__reaction-side.play-box__reaction-side--correct
                                | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                                | {{ timeExecutionString }}
                    result-buttons(
                        :exercise-id="exerciseId"
                        games-type="memoryDevelopment"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
            cs-loader(v-else='')
</template>

<script>
    import SecretsOfCiceroGameItems from '../../../../api/games/secretsOfCiceroGameItemsApi';
    import { cloneDeep, shuffle } from 'lodash';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import Rooms from './Rooms';
    import AnswerContainer from './AnswerContainer.vue';

    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA() {
        return {
            amountOfItemsInTheRoom: null,
            amountOfWordsInChain: null,
            inOrder: true,
            difficultWords: false,
            words: null,
            hideGameHeader: false,
            prepareForGame: true,
            answers: {
                good: 0,
                bad: 0,
            },
            amountOfCorrectWords: null,
            correctAnswers: [],
            incorrectAnswers: [],
            groupedCorrectAnswers: [],
            groupedCorrectAnswersArrayOfRows: [],
            groupedIncorrectAnswers: [],
            groupedIncorrectAnswersArrayOfRows: [],
            arrayOfAnswers: [],
            indexOfArray: 0,
            answersForEachTurn: {},
            arrayOfIndexes: [],
            indexForEachTurn: 0,
        };
    }

    export default {
        mixins: [playBoxGameMixin],
        data() {
            return DEFAULT_DATA();
        },
        methods: {
            chooseElement(item) {
                item.checked = !item.checked;
            },
            checkAnswers() {
                this.answers.good = 0;
                this.answersForEachTurn.arrays.forEach(item => {
                    if (item.checked) {
                        if (item.checked && item.isCorrect) {
                            this.answers.good++;
                            this.answers.good === this.groupedCorrectAnswers[1].length && this.getNextTurn();
                        } else {
                            this.answers.bad++;
                            item.checked = false;
                            item.verified = true;
                        }
                    }
                });
            },
            getNextTurn() {
                this.indexForEachTurn++;
                this.answersForEachTurn = {
                    arrays: shuffle(this.arrayOfAnswers[this.arrayOfIndexes[this.indexForEachTurn]]),
                    index: this.arrayOfIndexes[this.indexForEachTurn],
                };
                this.indexForEachTurn === this.arrayOfIndexes.length && this.gameDone();
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        this.assignDataFromParameters();

                        this.$createjs.Sound.removeAllSounds();
                        this.$createjs.Sound.removeAllEventListeners();
                        this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                        this.$createjs.Sound.registerSounds(this.soundObjects);

                        this.getExample();
                    })
                    .catch(() => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            assignDataFromParameters() {
                this.amountOfItemsInTheRoom = this.parameters.amountOfItemsInTheRoom;
                this.amountOfWordsInChain = this.parameters.amountOfWordsInChain;
                this.inOrder = this.parameters.inOrder;
                this.difficultWords = this.parameters.difficultWords;
            },
            getExample() {
                this.isLoading = true;
                let paramsForRequest = {
                    locale: this.user.locale,
                    type: this.parameters.type,
                    difficultWords: this.parameters.difficultWords,
                };
                SecretsOfCiceroGameItems.getSecretsOfCiceroByRequest(paramsForRequest)
                    .then(data => {
                        this.words = data;
                        this.getCorrectAnswersArray();
                        this.isLoading = false;
                        this.setTimer();
                    })
                    .catch(err => this.showErrorMessage(err));
            },
            getGroupedArrays(answers, groupedArray, groupedArrayOfRows) {
                for (let i = 0; i < this.amountOfItemsInTheRoom; i++) {
                    groupedArray.push(
                        answers.slice(
                            i * this.amountOfWordsInChain,
                            this.amountOfWordsInChain * i + this.amountOfWordsInChain
                        )
                    );
                    groupedArrayOfRows.push(groupedArray[i]);
                }
            },
            getCorrectAnswersArray() {
                this.amountOfCorrectWords = this.amountOfItemsInTheRoom * this.amountOfWordsInChain;
                this.correctAnswers = this.words.slice(0, this.amountOfCorrectWords).map(({ value }) => {
                    return {
                        value,
                        verified: false,
                        isCorrect: true,
                        checked: false,
                    };
                });
                this.incorrectAnswers = this.words
                    .slice(this.amountOfCorrectWords, this.words.length)
                    .map(({ value }) => {
                        return {
                            value,
                            verified: false,
                            isCorrect: false,
                            checked: false,
                        };
                    });
                this.getGroupedArrays(
                    this.correctAnswers,
                    this.groupedCorrectAnswers,
                    this.groupedCorrectAnswersArrayOfRows
                );
                this.getArrayOfIndexes();
                this.getArrayOfAnswers();
            },
            getArrayOfAnswers() {
                this.arrayOfAnswers = cloneDeep(this.groupedCorrectAnswersArrayOfRows);
                this.getGroupedArrays(
                    this.incorrectAnswers,
                    this.groupedIncorrectAnswers,
                    this.groupedIncorrectAnswersArrayOfRows
                );
                this.getAnswersForTheFirstTurn();
            },
            getAnswersForTheFirstTurn() {
                let count = 0;
                this.arrayOfAnswers.forEach(arr => {
                    arr.push(...this.groupedIncorrectAnswersArrayOfRows[count]);
                    count++;
                });
                if (this.inOrder) {
                    this.answersForEachTurn = {
                        arrays: shuffle(this.arrayOfAnswers[0]),
                        index: 0,
                    };
                } else {
                    this.answersForEachTurn = {
                        arrays: shuffle(this.arrayOfAnswers[this.arrayOfIndexes[0]]),
                        index: this.arrayOfIndexes[0],
                    };
                }
            },
            getArrayOfIndexes() {
                if (this.inOrder) {
                    for (let i = 0; i < this.amountOfItemsInTheRoom; i++) {
                        this.arrayOfIndexes.push(i);
                    }
                } else {
                    while (this.arrayOfIndexes.length < this.amountOfItemsInTheRoom) {
                        const r = Math.floor(Math.random() * this.amountOfItemsInTheRoom);
                        if (this.arrayOfIndexes.indexOf(r) === -1) {
                            this.arrayOfIndexes.push(r);
                        }
                    }
                }
            },
            refreshGameStatBeforeSend() {
                this.gameStat.answers = this.amountOfCorrectWords;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            calculatePercent() {
                let total = this.amountOfCorrectWords;
                let goodAnswers = this.amountOfCorrectWords - this.answers.bad;
                if (total > 0) {
                    return parseInt((goodAnswers / total) * 100);
                }
                return 0;
            },
            resetData() {
                this.hideGameHeader = false;
                this.gameStarted = false;
                this.stopTimer();
                this.timer = null;
                this.itemsForAnswersBox = [];
                if (this.answerTimer) {
                    clearInterval(this.answerTimer);
                    this.answerTimer = null;
                }
            },
            gameDone() {
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play('gameDone');
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
                this.gameFinished = true;
                this.sendStat();
            },
            startGame() {
                this.stopTimer();
                this.gameStarted = true;
            },
            beforeGameRestart() {
                this.resetData();
                Object.assign(this, DEFAULT_DATA());
            },
        },
        computed: {
            timeExecutionString() {
                return this.time + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_seconds', this.time);
            },
        },
        components: {
            Rooms,
            AnswerContainer,
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/games/playbox.scss';

    .play-box--warning {
        display: table;
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .component-container {
        display: flex;
        justify-content: center;
        flex-direction: column;
        flex-wrap: wrap;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .component-container__block {
        display: flex;
        flex-direction: column;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .button-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        @include media($lg) {
            justify-content: flex-start;
        }
    }

    .list__button {
        height: 50px;
        width: 155px;
        font-size: 16px;
        margin-top: 20px;
        @include media($lg) {
            margin-left: 20px;
        }
        @include media($xl) {
            height: 65px;
            width: 180px;
            font-size: 20px;
            margin-left: 50px;
        }
    }

    .revived-numbers-game-container__result-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
    }
    .revived-numbers-game-container_before-start {
        justify-content: space-around;
    }

    .revived-numbers-game-container__result-image {
        @include stack-space($space-base);
    }

    .revived-numbers-game-container__interactive-place {
        margin: 0;
        flex: 1 1 auto;
        width: 100%;
        min-height: 100%;
        display: inline-flex;
        justify-content: flex-start;
        flex-direction: column;
    }

    .play-box {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

    .play-box__time {
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        color: $hsl-color-green-58;
        margin-bottom: 30px;
    }

    .play-box__image {
        max-width: 100%;
        height: 90% !important;
        margin-bottom: 20px;
        @include media($md) {
            margin-bottom: 30px;
        }
    }

    .play-box__reaction {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-grow: 1;
        flex-shrink: 1;
        flex-wrap: wrap;
        width: 100%;
        flex-direction: column;
        @include stack-space($space-base);
        @include media($md) {
            flex-wrap: nowrap;
        }
        @media screen and (max-width: 655px) {
            justify-content: space-between;
        }
    }

    .play-box__reaction-side {
        align-self: normal;
        font-weight: 500;
        font-size: 20px;
        margin-bottom: 10px;
        @include media($sm) {
            width: auto;
            font-size: 28px;
        }
        @include media($md) {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            flex-grow: 1;
            align-self: center;
            font-size: 20px;
        }
        @media screen and ($md) and (max-width: 800px) {
            font-size: 18px;
        }
        @include media($lg) {
            margin-bottom: 15px;
            font-size: 30px;
        }
        color: $hsl-color-green-58;
    }

    .play-box__reaction-side--correct {
        color: $hsl-color-green-58;
    }
</style>
